var map = {
	"./img1.jpg": 2406,
	"./img10.jpg": 2407,
	"./img2.jpg": 2408,
	"./img3.jpg": 2409,
	"./img4.jpg": 2410,
	"./img5.jpg": 2411,
	"./img6.jpg": 2412,
	"./img7.jpg": 2413,
	"./img8.jpg": 2414,
	"./img9.jpg": 2415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2405;